export enum EOpenPoseCursorAxis {
  NONE = '',

  X = 'X',
  Y = 'Y',
  Z = 'Z',
}
